import configurations from "./configurationsPT.json";
import paymentConfig from "./paymentConfigPT.json";
import retailerConfig from "./retailerConfigPT.json";

export const configurationsPT = {
	configurations,
	paymentConfig,
	retailerConfig,
};
